import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

import { submenuMyAccount } from 'constants/submenuMyAccount';
import { submenuMyCampus } from 'constants/submenuMyCampus';

import classes from './Submenu.module.css';

const Submenu = props => {
  const dataUser = useSelector(state => state.userInfo);
  const url = window.location.pathname.split('/');
  const [valueTab, setValueTab] = useState(props.sectionTab);
  const [showSpecialTab, setShowSpecialTab] = useState(false);
  const [menu] = useState(
    props.section === 'myAccount'
      ? submenuMyAccount
      : submenuMyCampus
  );

  useEffect(() => {
    const principalemail = dataUser.data.email.split('@');
    if (principalemail[1] === 'universidaddelasciencias.edu.mx') {
      setShowSpecialTab(true);
    }
    dataUser.data.aliasDetails.map(item => {
      if (item.email === 1) {
        const email = item.alias.split('@');
        if (email[1] === 'universidaddelasciencias.edu.mx') {
          setShowSpecialTab(true);
        }
      }
    });
  }, []);

  useEffect(() => {
    if (props.section === 'myAccount') {
      if (!url[2]) {
        props.changeSection('all');
        setValueTab('all');
      }
    }
  }, [url]);

  const handleChange = (event, newValue) => {
    props.changeSection(newValue);
    setValueTab(newValue);
  };

  return (
    <div className={classes.menuContainer}>
      <aside className={classes.sectionContainer}>
        <p className={classes.sectionText}>{props.sectionTitle}</p>
      </aside>
      {props.menu && (
        <Tabs
          TabIndicatorProps={{ style: { background: '#333549' } }}
          className={classes.storeBar}
          value={valueTab}
          onChange={handleChange}
        >
          {menu.map(item => (
            <Tab
              key={item.value}
              className={
                item.value === 'udcLessons' && !showSpecialTab
                  ? classes.itemHide
                  : valueTab === `${item.value}`
                  ? classes.itemSelected
                  : classes.item
              }
              component={Link}
              to={item.link}
              label={item.text}
              value={item.value}
            />
          ))}
        </Tabs>
      )}
    </div>
  );
};

Submenu.propTypes = {
  // eslint-disable-next-line react/require-default-props
  changeSection: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  sectionTab: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  sectionTitle: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  section: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  menu: PropTypes.bool
};

export default Submenu;
